// libreria para llamar un php en modo ajax
// estas son formas de llamar las variables
// import ajaxphp from '@/js/components/ajax/ajaxphp'
// let respuesta
// let inputs
// const path = document.querySelector('#path')
// const phpfile = path.value + '/parts/ajax/ajax-contacto-dekaz.php'
// inputs = {
//     'code': 'code',
// }
function ajaxphp(phpfile, data, callback){
    var datajson = '';
    Object.keys(data).forEach(function(key) {
        datajson = datajson + key + '=' + data[key] + '&';      
      });
    datajson = datajson.substring(0, datajson.length-1)
    var xhr = new XMLHttpRequest();
    xhr.open('POST', phpfile, true);
    xhr.setRequestHeader('Content-type','application/x-www-form-urlencoded');
    xhr.onload = function(){
        if(xhr.status === 200){

            callback(null, xhr.responseText)
        } else{
            callback('Error: ' + xhr.status)
        }
    }
    xhr.send(datajson);
}

export default ajaxphp